export const PhotoSlot = ({
  caption,
  ratio = "aspect-[4/5]",
  dark = false,
  testid = "photo-slot",
  src,
  alt = "",
  position = "object-center",
}) => {
  if (src) {
    return (
      <figure
        data-testid={testid}
        className={`relative w-full overflow-hidden ${ratio}`}
      >
        <img
          src={src}
          alt={alt}
          loading="lazy"
          className={`absolute inset-0 h-full w-full object-cover ${position}`}
        />
      </figure>
    );
  }
  return (
    <figure
      data-testid={testid}
      className={`relative w-full overflow-hidden border ${ratio} ${
        dark ? "border-paper/20 bg-paper/5" : "border-ink/15 bg-paper2"
      }`}
    >
      {[
        "left-3 top-3 border-l border-t",
        "right-3 top-3 border-r border-t",
        "left-3 bottom-3 border-l border-b",
        "right-3 bottom-3 border-r border-b",
      ].map((pos) => (
        <span
          key={pos}
          aria-hidden="true"
          className={`absolute h-4 w-4 ${pos} ${
            dark ? "border-paper/40" : "border-ink/30"
          }`}
        />
      ))}
      <figcaption
        className={`absolute inset-x-0 bottom-0 p-6 md:p-8 font-cormorant italic text-base md:text-lg leading-snug ${
          dark ? "text-paper/50" : "text-ink/45"
        }`}
      >
        {caption}
      </figcaption>
    </figure>
  );
};
